import { TrackPayload } from '@getvim/internal-vim-os-sdk/types';
import { Tab } from '../types';
import { CurrentContext } from '../types/currentContext';
import { AnalyticsContext, PriorAuthAnalyticsEvents } from './types';
import { getContextForAnalytics } from './analyticsUtils';

export interface PriorAuthAnalyticsClient {
  trackAnalytics: (payload: TrackPayload) => void;
}

export class PriorAuthAnalyticsManager {
  private context: AnalyticsContext | undefined;

  private static analyticsClient: PriorAuthAnalyticsClient;

  public static setAnalyticsClient(client: PriorAuthAnalyticsClient): void {
    PriorAuthAnalyticsManager.analyticsClient = client;
  }

  public setContext(currentContext: CurrentContext, tabName: Tab): void {
    this.context = getContextForAnalytics(currentContext, tabName);
  }

  public track<T extends keyof PriorAuthAnalyticsEvents>(
    event: T,
    properties: PriorAuthAnalyticsEvents[T] & { vim_insurer?: string },
  ): void {
    const { vim_insurer, ...restProperties } = properties;
    PriorAuthAnalyticsManager.analyticsClient.trackAnalytics({
      event,
      properties: {
        ...restProperties,
        vim_insurer: vim_insurer || this.context?.vim_insurer,
      },
    });
  }

  public trackWithContext<T extends keyof PriorAuthAnalyticsEvents>(
    event: T,
    properties: Partial<PriorAuthAnalyticsEvents[T]>,
  ): void {
    PriorAuthAnalyticsManager.analyticsClient.trackAnalytics({
      event,
      properties: {
        ...properties,
        ...this.context,
      },
    });
  }
}

export const analyticsManager = new PriorAuthAnalyticsManager();
